import api from '../../../../App/socket';

export const changeUserEmail = (_id, update, email_id) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedUpdate',
        options: {
            attributes: ['name'],
            where: { _id },
            fullPath: `person.emails.${email_id}`,
            update,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_emails_requests/change_user_email_request.js